import React from 'react';
import { Content } from '~/layouts/Dash/components';


const BasicContent = ({breadcrumb, children}) => {

  const breadcrumbs = [
    {
      label: 'Meus Empreendimentos',
      to: '/empreendimentos/meus_empreendimentos',
      active: false,
    },
    breadcrumb,
  ];
  return (
    <Content breadcrumbs={breadcrumbs} title="Meus Empreendimentos">
      {children}
    </Content>
  );
}

export default BasicContent;
